/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Exercise_ExcludedInputs */

const en_us2_plan_exercise_excluded = /** @type {(inputs: Plan_Exercise_ExcludedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You asked us not to recommend that exercise, so it stays out of the plan.`)
};

const pt_br2_plan_exercise_excluded = /** @type {(inputs: Plan_Exercise_ExcludedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Você pediu para não recomendarmos esse exercício, então ele não entra no plano.`)
};

const es_419_plan_exercise_excluded = /** @type {(inputs: Plan_Exercise_ExcludedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pediste que no te recomendáramos ese ejercicio, así que queda fuera del plan.`)
};

const pt_pt2_plan_exercise_excluded = /** @type {(inputs: Plan_Exercise_ExcludedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pediste-nos para não recomendarmos esse exercício, por isso não entra no plano.`)
};

const fr_fr2_plan_exercise_excluded = /** @type {(inputs: Plan_Exercise_ExcludedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu nous as demandé de ne pas recommander cet exercice, il reste donc hors du programme.`)
};

const de_de2_plan_exercise_excluded = /** @type {(inputs: Plan_Exercise_ExcludedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du hast uns gebeten, diese Übung nicht zu empfehlen, daher bleibt sie aus dem Plan.`)
};

const it_it2_plan_exercise_excluded = /** @type {(inputs: Plan_Exercise_ExcludedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ci hai chiesto di non consigliare quell'esercizio, quindi resta fuori dalla scheda.`)
};

/**
* | output |
* | --- |
* | "You asked us not to recommend that exercise, so it stays out of the plan." |
*
* @param {Plan_Exercise_ExcludedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_exercise_excluded = /** @type {((inputs?: Plan_Exercise_ExcludedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Exercise_ExcludedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_exercise_excluded(inputs)
	if (locale === "es-419") return es_419_plan_exercise_excluded(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_exercise_excluded(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_exercise_excluded(inputs)
	if (locale === "de-DE") return de_de2_plan_exercise_excluded(inputs)
	if (locale === "it-IT") return it_it2_plan_exercise_excluded(inputs)
	return en_us2_plan_exercise_excluded(inputs)
});
export { plan_exercise_excluded as "plan.exercise_excluded" }